<button type="button" role="option" *ngFor="let tab of tabs" (click)="selectTab(tab)" [ariaSelected]="tab === selectedTab">{{ tab }}</button>
